import api from "../../../shared/api/client";

export async function getCommissionRules() {
  const { data } = await api.get("/commission-rules");
  return data;
}

export async function createCommissionRule(body) {
  const { data } = await api.post("/commission-rules", body);
  return data;
}

export async function deleteCommissionRule(staffCode, manufacturerCode) {
  const { data } = await api.delete(
    `/commission-rules/${staffCode}/${manufacturerCode}`,
  );
  return data;
}

export async function getCommissionFormulas() {
  const { data } = await api.get("/commission-formulas");
  return data;
}

export async function createCommissionFormula(body) {
  const { data } = await api.post("/commission-formulas", body);
  return data;
}

export async function deleteCommissionFormula(formulaId) {
  const { data } = await api.delete(`/commission-formulas/${formulaId}`);
  return data;
}

export async function testCommissionFormula(body) {
  const { data } = await api.post("/commission-formulas/test", body);
  return data;
}

export async function getCoefficientTables() {
  const { data } = await api.get("/coefficient-tables");
  return data;
}

export async function saveCoefficientTable(body) {
  const { data } = await api.post("/coefficient-tables", body);
  return data;
}

export async function deleteCoefficientTable(tableId) {
  const { data } = await api.delete(`/coefficient-tables/${tableId}`);
  return data;
}

export async function calculatePersonnelCommission(body) {
  const { data } = await api.post("/personnel-commission/calculate", body);
  return data;
}

export async function getPersonnelCommissionResults(params) {
  const { data } = await api.get("/personnel-commission", { params });
  return data;
}
